export const DynamicTitle = (newTitle) => {
  return document.title = newTitle;
}